import { useEffect, useState } from 'react';

/** Hvor ofte version.json hentes (ms). */
export const NEW_VERSION_POLL_MS = 5 * 60 * 1000;

/** Bundlens eget build-id; konstant i dev og vitest. */
export const CURRENT_BUILD: string = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';

/**
 * Opdager, at en ny frontend er deployet: henter /version.json (uden cache) hvert 5. minut
 * og når fanen bliver synlig. Afviger build-id'et fra bundlens, returneres true.
 * Fejl ved hentning ignoreres stille. Når en ny build først er set, stoppes tjekket.
 */
export function useNewVersion(currentBuild: string = CURRENT_BUILD): boolean {
  const [hasNew, setHasNew] = useState(false);

  useEffect(() => {
    if (hasNew) return undefined;
    let cancelled = false;

    async function check() {
      try {
        const response = await fetch('/version.json', { cache: 'no-store' });
        if (!response.ok) return;
        const data = (await response.json()) as { build?: unknown };
        if (!cancelled && typeof data.build === 'string' && data.build !== currentBuild) {
          setHasNew(true);
        }
      } catch {
        /* ignoreres stille */
      }
    }

    const timer = window.setInterval(check, NEW_VERSION_POLL_MS);
    function onVisible() {
      if (document.visibilityState === 'visible') void check();
    }
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [hasNew, currentBuild]);

  return hasNew;
}
